import React, { useState, useContext } from 'react';
import {
  useDataModel, extend, params, shape, string, arrayOf
} from '@thd-nucleus/data-sources';
import { string as stringType } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames/bind';
import {
  DropDown,
  DropDownItem,
  DropDownSearch,
  Row,
  Col,
  Placeholder
} from '@thd-olt-component-react/core-ui';
import styles from './store-hero-dropdown.scss';

const cx = classNames.bind(styles);

const StoreHeroDropdown = ({ storeZip }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const { data, loading, error } = useDataModel('storeServices', { variables: { zipCode: storeZip } });
  const services = data?.storeServices?.storeServices || [];
  const sanatizedList = [];
  const [filteredItems, setFilteredItems] = useState(sanatizedList);

  if (loading) {
    return (
      <Placeholder type="rect" height="40px" width="100%" />
    );
  }

  services.forEach((service) => {
    sanatizedList.push({ name: service?.name, leadPageUrl: '' });
    service.storeServiceSubCategories.forEach((subItem) => {
      sanatizedList.push({
        name: subItem?.name,
        leadPageUrl: subItem?.leadPageUrl
      });
    });
  });

  if (sanatizedList.length !== 0 && filteredItems.length === 0) {
    setFilteredItems(sanatizedList);
  }

  const handleButtonClick = (leadPageUrl) => {
    window.open(leadPageUrl, isMobile ? '_self' : '_blank');
  };

  const onSearchChange = (value = '') => {
    const updatedItems = sanatizedList.filter((item) => {
      return (item.name || '').toUpperCase()
        .includes(value.toUpperCase());
    });
    setFilteredItems(updatedItems);
  };
  return (
    <>
      {sanatizedList.length !== 0 && (
        <Row>
          <Col
            flatten
            nopadding
          >
            <DropDown header="Let us help you with..." enableScrolling>
              <DropDownSearch onChange={onSearchChange} />
              {
                filteredItems?.map((item, index) => (
                  <DropDownItem
                    key={index}
                    className={cx(!item?.leadPageUrl ? 'store-hero-dropdown__title' : '')}
                    onClick={() => { handleButtonClick(item?.leadPageUrl); }}
                  >
                    {item?.name}
                  </DropDownItem>
                ))
              }
            </DropDown>
          </Col>
        </Row>
      )}
    </>
  );
};

StoreHeroDropdown.propTypes = {
  storeZip: stringType
};

StoreHeroDropdown.defaultProps = {
  storeZip: '30339'
};

StoreHeroDropdown.dataModel = extend({
  storeServices: params({ zipCode: string().isRequired() }).shape({
    storeServices: arrayOf(shape({
      name: string(),
      namespace: string(),
      imageUrl: string(),
      storeServiceSubCategories: arrayOf(shape({
        name: string(),
        rank: string(),
        leadPageUrl: string()
      })),
    })),
  }),
});

export { StoreHeroDropdown };
